import {Injectable} from "@angular/core";
import {environment} from "../../../../environments/environment.dev";


@Injectable({providedIn: 'root'})
export class RoleHierarchyService {

    private hierarchy: Map<string, string[]> = environment.roles;

    getReachableRoles(role: string): string[] {
        return this.hierarchy.get(role) || [];
    }

    anyRoleReachable(roles: string[], targetRole: string): boolean {
        return roles.some(role => this.isRoleReachable(role, targetRole));
    }

    isRoleReachable(role: string, targetRole: string): boolean {
        if (role === targetRole) { return true; }
        const reachableRoles = this.getReachableRoles(role);
        return reachableRoles.some(reachableRole => this.isRoleReachable(reachableRole, targetRole));
    }
}